import { ContactUs } from '@/pages/contact-us'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/contact-us')({
  component: ContactUs,
})